import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import Select from "react-select";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import AsyncSelect from 'react-select/async';


export default function CreateCredit({ show, closeModal, refreshPage }) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [company, setCompany] = useState([]);
  const [creditLevel, setCreditLevel] = useState(null);
  const [creditPeriod, setCreditPeriod] = useState("");
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);


  const creditLevels = {
    level1: {
      wet: "28-day credit period",
      dry: "14-day credit period",
    },
    level2: {
      wet: "28-day credit period",
      dry: "7-day credit period",
    },
  };

  const [formData, setFormData] = useState({
    company_detail_id: "",
    credit_level: "",
    product_type: "", // This can be 'wet' or 'dry'
  });

  const resetForm = () => {
    setFormData({
      company_detail_id: "",
      credit_level: "",
      product_type: "",
    });
    setCreditLevel(null);
    setCreditPeriod("");
    setValidationError({});
  };

  // useEffect(() => {
  //   const fetchCustomerCompany = async () => {
  //     try {
  //       const response = await axiosInstance.get(
  //         `/user/company/fetch-company-details`
  //       );

  //       setCompany(
  //         response.data.data.company.map((com) => ({
  //           value: com.id,
  //           label: com.company_name,
  //         }))
  //       );

  //     } catch (error) {
  //       console.error("Error fetching customer company", error);
  //     }
  //   };
  //   fetchCustomerCompany();
  // }, []);

  const loadCustomerOptions = (inputValue, callback) => {
    setIsCompanyLoading(true);
    axiosInstance
      .get(`/user/company/fetch-company-details?search=${inputValue}`)
      .then((response) => {
        const options = response.data.data.company.map((com) => ({
          label: `${com.company_name}`,
          value: com.id,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error("Error fetching company", error);
        callback([]);
      });
  };

  const handleChangeCompany = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      company_detail_id: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleChangeCreditLevel = (selectedOption) => {
    setCreditLevel(selectedOption);
    setCreditPeriod(""); // Reset the credit period when credit level changes

    // Set the corresponding credit period based on selected level
    setFormData((prevFormData) => ({
      ...prevFormData,
      credit_level: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleChangeProductType = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      product_type: selectedOption ? selectedOption.value : "",
    }));

    // Set the credit period based on the selected product type
    if (selectedOption) {
      const levelKey = creditLevel.value; // e.g., 'level1' or 'level2'
      const period = creditLevels[levelKey][selectedOption.value];
      setCreditPeriod(period);
    }
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axiosInstance.post(
        "/user/credit/create",
        formData
      );
      toast.success("Credit requested successfully");

      handleClose();
      refreshPage();
    } catch (error) {
      console.error("Error creating credit:", error);

      if (error.response && error.response.data && error.response.data.errors) {
        setValidationError(error.response.data.errors);
      } else {
        toast.error("Error requesting credit. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

 

  return (
    <div className="CreateCSP">
      <Modal show={show} onHide={handleClose} dialogClassName="modal-md">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Credit Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group row">
              <div className="col-12">
                <Form.Group controlId="companyInput">
                  <div className="input-group mb-2">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        Company Name
                      </span>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                      {/* <Select
                        options={company}
                        onChange={handleChangeCompany}
                        value={company.find(
                          (com) => com.value === formData.company_detail_id
                        )}
                        isSearchable
                        placeholder="-- Select Company --"
                      /> */}
                      <AsyncSelect
                        cacheOptions
                        defaultOptions
                        loadOptions={loadCustomerOptions}
                        onChange={handleChangeCompany}
                        value={company.find((opt) => opt.value === formData.company_detail_id)}
                        isSearchable
                        placeholder="-- Select Company --"
                      />
                    </div>
                  </div>
                  {validationError.company_detail_id && (
                    <small className="text-danger my-1">
                      {validationError.company_detail_id[0]}
                    </small>
                  )}
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="creditLevelInput">
                  <div className="input-group mb-2">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        Credit Level
                      </span>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                      <Select
                        options={[
                          { value: 1, label: "Credit Level 1" },
                          { value: 2, label: "Credit Level 2" },
                        ]}
                        onChange={handleChangeCreditLevel}
                        value={creditLevel}
                        isSearchable
                        placeholder="-- Select Credit Level --"
                      />
                    </div>
                  </div>
                  {validationError.credit_level && (
                    <small className="text-danger my-1">
                      {validationError.credit_level[0]}
                    </small>
                  )}
                </Form.Group>
              </div>
              {/* <div className="col-12">
                {creditLevel && (
                  <Form.Group controlId="productTypeInput">
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          Product Type
                        </span>
                      </div>
                      <div style={{ flexGrow: 1 }}>
                        <Select
                          options={[
                            { value: "wet", label: "Wet Products" },
                            { value: "dry", label: "Dry Products" },
                          ]}
                          onChange={handleChangeProductType}
                          isSearchable
                          placeholder="-- Select Product Type --"
                        />
                      </div>
                    </div>
                    {validationError.product_type && (
                      <small className="text-danger my-1">
                        {validationError.product_type[0]}
                      </small>
                    )}
                  </Form.Group>
                )}
              </div>
              {creditPeriod && (
                <div className="col-12">
                  <p>Credit Period: {creditPeriod}</p>
                </div>
              )} */}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className=""
              style={{
                backgroundColor: "#c4281b",
                color: "#fff",
                border: "none",
              }}
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}
